<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<div class="message-container">
		<div :class="{'message-wrapper':true, 'disable-scroll':shouldDisableScroll}" id="messages-mobile" ref="messagesChatMobile">
			<b-row  v-if="value"  v-for=" (m, mindex) in value.slice().reverse()" :key="'mindex'+mindex" :class="visibleClasses(mindex)">
				<b-col>
					<div :class="messageClasses(mindex)">
					<b-row>
					<b-col class="message__name"><span v-if="m.sourceTable == 'lcr_change_message'  && m.sourceTable != sourceTable">Changes requested from </span> {{m.firstName}} {{m.lastName}}, {{m.organizationName}}<span v-if="m.sourceTable == 'contravention_message' && m.sourceTable != sourceTable">&nbsp;(<router-link :to="'/lane-closure-request/'+laneClosureRequestId+'/view-contravention/'+m.sourceId">Violation #{{m.sourceId}}</router-link>)</span></b-col>
					</b-row>
					<div v-if="m.replyToId.value != null" class="message__replyto">{{getReplyToMessage(m.replyToId.value)}}</div>
					<div class="message__message" v-html="m.message.value"></div>
					<b-row>
					<b-col class="message__date text-right">{{Format.toLocalDateTime(m.messageDateTime.value, 'MMMM D, Y H:mm:ss')}}</b-col>
					</b-row>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="value.length == 0">
				<b-col class="pt-3">
				<strong>No messages have been sent for this request.</strong>
				</b-col>
			</b-row>
			<b-row v-if="1 == 2 && value.length > 3 && readingAll == false" class="pt-3">
				<b-col class="text-center">
					<b-button  :disabled="isButtonDisabled" type="button" variant="light-blue" @click="onReadAll">Read Remaining {{value.length-3}} Messages</b-button>
				</b-col>
			</b-row>
			<div id="message-box-bottom">&nbsp;</div>
			<div id="message-box-bottom-ios">&nbsp;</div>
		</div>
			<div class="message-box-wrapper" id="message-box-wrapper">
				<div class="d-flex">
				<div class="flex-grow-1 message-box-wrapper__text">
		             <div ref="textAreaContainer" class="relative flex-grow items-center">
		                 <textarea
		                     placeholder="Type a message"
		                     ref="conversationTextArea"
		                     rows="1"
					 		 max-rows="6"
				  			v-model="message.value"
		                     class="absolute"
		                     :style="textareaInline"
		                     @keyup="manageTextAreaHeight($event)"
		                 >
		                 </textarea>
		             </div>
				</div>
				<div class="flex-grow-1 message-box-wrapper__send">
					<button :disabled="isButtonDisabled"  type="button" @click="onSend"><span v-if="!busy"><font-awesome-icon icon="paper-plane" /></span><b-spinner small label="Loading..." class="ml-2" v-if="busy"></b-spinner></button>
				</div>
			</div>
			</div>
			</div>

</template>

<script>
import BootstrapField from '../utility/BootstrapField';
import Vue from 'vue'
import Format from '../utility/Format';

export default {
	name: 'LaneClosureRequestChatMobile',
	props: ['value','laneClosureRequestId', 'sourceTable','busy'],
	data() {
		return {
			Format,
			message: new BootstrapField({
				value:""
			}),
			replyToId: new BootstrapField({
			}),
			readingAll: true,
			textAreaMaxHeight: 0,
			textareaInline: {
			    maxHeight: "40vh",
			    overflow: "hidden",
			    height: "32px",
			},
			isButtonDisabled:false,
			hasBeenShown:false

		}
	},
	created() {
		window.addEventListener("resize", this.setTextAreaMax);

		Vue.prototype.$bus.$on('keyboard:willShow', this.keyboardWillShow);
		Vue.prototype.$bus.$on('keyboard:didShow', this.keyboardDidShow);
		Vue.prototype.$bus.$on('keyboard:willHide', this.keyboardWillHide);
		Vue.prototype.$bus.$on('keyboard:didHide', this.keyboardDidHide);
		Vue.prototype.$bus.$on('message:success', this.handleSuccess);
		Vue.prototype.$bus.$on('message:error', this.handleError);
	},
	destroyed() {
	    window.removeEventListener("resize", this.setTextAreaMax);
	    Vue.prototype.$bus.$off('keyboard:willShow', this.keyboardWillShow);
	    Vue.prototype.$bus.$off('keyboard:didShow', this.keyboardDidShow);
	    Vue.prototype.$bus.$off('keyboard:willHide', this.keyboardWillHide);
	    Vue.prototype.$bus.$off('keyboard:didHide', this.keyboardDidHide);
	    Vue.prototype.$bus.$off('message:success', this.handleSuccess);
	    Vue.prototype.$bus.$off('message:error', this.handleError);
	},
	mounted() {
		this.setTextAreaMax();
		Vue.nextTick(() => {
			if (document.getElementById("message-box-bottom") && document.getElementById("messages-mobile")) {
				let that = this;
				setTimeout(() => {
					that.$smoothScroll({
					  scrollTo: document.getElementById("message-box-bottom"),
					  container:document.getElementById("messages-mobile"),
					  duration: 0,
					  offset: 0,
					});
				}, 500);
			} else {
				this.tryScrollBottom();
			}
		});
   },
   watch: {
   },
	computed: {
		shouldDisableScroll() {
			let disableScroll = false;
			if (this.value == null) {
				disableScroll = true;
			} else {
				if (this.value.length == 0) {
					disableScroll = true;
				}
			}
			return disableScroll;
		}
	},
	methods: {
		tryScrollBottom() {
			console.log("tryScrollBottom");
			let that = this;
			if (document.getElementById("message-box-bottom") && document.getElementById("messages-mobile")) {
				setTimeout(() => {
					if (document.getElementById("message-box-bottom") && document.getElementById("messages-mobile")) {
						that.$smoothScroll({
						  scrollTo: document.getElementById("message-box-bottom"),
						  container:document.getElementById("messages-mobile"),
						  duration: 0,
						  offset: 0,
						});
					}
				}, 500);
			} else {
				setTimeout(() => {
					that.tryScrollBottom();
				}, 50);
			}
		},
		keyboardWillShow() {
			var height = this.$store.getters['keyboardHeight'];
			if (height == null) {
				height = 300;
			}


			 if (document.body.classList.contains('is-android')) {
			 	// android's keyboard works differently.
				document.getElementById("message-box-wrapper").style.bottom = "0px";

			 } else {
			document.getElementById("message-box-wrapper").style.bottom = height + "px";

			 }

		},
		keyboardWillHide() {
			// document.getElementById("messages-mobile").style.bottom = "0px";
			document.getElementById("messages-mobile").style.bottom = document.getElementById("message-box-wrapper").offsetHeight +"px";
			document.getElementById("message-box-wrapper").style.bottom = "0px";
		},

		keyboardDidShow() {
			var height = this.$store.getters['keyboardHeight'];
			if (height == null) {
				height = 300;
			}

			height = height + document.getElementById("message-box-wrapper").offsetHeight; // height of the text area field...

			 if (document.body.classList.contains('is-android')) {
			 	// android's keyboard works differently.
				document.getElementById("messages-mobile").style.bottom = "0px";
			 } else {
			document.getElementById("messages-mobile").style.bottom = height + "px";

			 }


			// var height = this.$store.getters['keyboardHeight'];
			// console.log(height);
			// if (height == null) {
			// 	height = "300";
			// } else {
			// }
			// document.getElementById("message-box-wrapper").style.bottom = height + "px";
		},
		keyboardDidHide() {
			document.getElementById("message-box-wrapper").style.bottom = "0px";
			document.getElementById("messages-mobile").style.bottom = "95px";

		},

		setTextAreaMax() {
		    let convTextArea = this.$refs.conversationTextArea;
		    let compStyles = window.getComputedStyle(convTextArea);
		    this.textAreaMaxHeight = compStyles.getPropertyValue("max-height");
		},
		manageTextAreaHeight(e) {
		    let ele = e.target;
		    this.textareaInline.height = "auto";
		    Vue.nextTick(() => {
		        // this.textareaInline.height = ele.offsetHeight - 2 === ele.scrollHeight? "2.75rem": `${ele.scrollHeight + 10}px`;
		        // console.log(ele.offsetHeight);
		        // console.log(ele.scrollHeight);
		        // console.log(this.textareaInline.height);

		        this.textareaInline.height = ele.offsetHeight - 2 === ele.scrollHeight? "32px": `${ele.scrollHeight + 0}px`;

		        this.$refs.textAreaContainer.height = ele.scrollHeight + 0;

		        // console.log(document.getElementById("message-box-wrapper").style);
				// let height = document.getElementById("message-box-wrapper").offsetHeight; // height of the text area field...
				// document.getElementById("messages-mobile").style.bottom = height + "px";


		        let calcMaxHeight = parseInt(this.textAreaMaxHeight.replace("px", ""));




		        if (ele.scrollHeight + 0 >= calcMaxHeight) {
		            this.textareaInline.overflow = "auto";
		        } else {
		            this.textareaInline.overflow = "hidden";
		        }
		    });
		},


		visibleClasses(index) {
			let classes = "message-entry-wrapper";
			if (index > 2) {
				classes += " message-hidden";
			}
			if (this.readingAll) {
				classes += " reading-all-messages";
			}
			return classes;
		},
		messageClasses(index) {
			// have to reverse the index.
			if (this.value) {
				index = this.value.length - index - 1;
				if (index < 0) {
					index = 0;
				}
			}

			let classes = "message";
			if (this.value[index].sourceTable == 'lcr_change_message') {
				classes += " lcr-change-message";
			}
			if (this.value[index].userId == this.$store.getters.userId()) {
				classes += " self";
			}
			return classes;
		},
		getReplyToMessage(id) {
			return null;
		},
		onReadAll() {
			this.readingAll = true;

		},
		onSend() {
			if (this.message.value.trim() != "" && this.message.value != null) {
				this.isButtonDisabled = true;
				let msg = this.message.value;
				msg = msg.replace(/(?:\r\n|\r|\n)/g, '<br/>');
				this.$emit("message:newMessage", {
					message:msg,
					replyToId: this.replyToId.value,
					sourceId:this.laneClosureRequestId,
					sourceTable:this.sourceTable
				});
			}
		},
		handleSuccess() {
			this.isButtonDisabled = false;
			this.$smoothScroll({
			  scrollTo: document.getElementById("message-box-bottom"),
			  container:document.getElementById("messages-mobile"),
			  duration: 1000,
			  offset: 0,
			});
			this.message.value = "";
			this.textareaInline.height = "auto";
			// document.getElementById("message-box-bottom").scrollIntoView({behavior: 'smooth'});
			// document.getElementById("message-box-bottom").scrollIntoView({block: "end", inline: "nearest",behavior: 'smooth'});
			// document.getElementById("messages-mobile").scrollBy(0,-5);

		},
		handleError() {
			this.isButtonDisabled = false;

		}

	}
}
</script>
